import { useState } from 'react';
import { useResource } from 'app/utils/hooks';
import { fetchLanguageCodesDDLEffect } from 'app/store/SongList/effects';
import { getLanguageCodesSelector } from 'app/store/SongList/selectors';
import { useAppSelector } from 'app/store';
import {
  getRelease,
  getReleaseVersion,
  getVersionSyncStatus,
  getVersionTypes,
} from 'app/store/Releases/selectors';
import {
  useFetchAudioDependencies,
  useFetchPrimaryAudio,
  useReplaceAudioVersion,
  useUpdateAudioDetails,
  useUpdateVersion,
  useValidations,
} from '../hooks';
import {
  AudioData,
  getPreferredAudioSelectionOption,
} from '../TuneCoreVersionDetailsForm/utils';
import { VersionAudioComponent } from './VersionAudioComponent';
import { VersionAudioLoader } from './VersionAudioLoader';

export const VersionAudio = () => {
  const release = useAppSelector(getRelease);
  const releaseVersion = useAppSelector(getReleaseVersion);
  const isSyncing =
    useAppSelector((state) =>
      getVersionSyncStatus(state, releaseVersion?.song.versionGuid || '')
    ) || false;

  const [audioData, setAudioData] = useState<AudioData>({ items: [] });
  const { audioDataLoading } = useFetchAudioDependencies(setAudioData);

  const {
    primaryAudioFetching,
    setPrimaryAudioFetching,
    primaryAudio,
    setPrimaryAudio,
  } = useFetchPrimaryAudio();

  const { replaceAudioVersion, isAudioReplacing } = useReplaceAudioVersion(
    setPrimaryAudioFetching
  );

  const [languageCodes, languageCodesLoading] = useResource(
    fetchLanguageCodesDDLEffect,
    getLanguageCodesSelector
  );

  const versionTypesDDL = useAppSelector(getVersionTypes);

  const {
    validationsLoading,
    versionValidations,
    versionSongValidations,
    fetchAudioDetailsValidations,
    updateVersionAudioValidations,
  } = useValidations();

  const { updateVersion } = useUpdateVersion(release?.type);

  const { updateAudioDetails } = useUpdateAudioDetails(
    setPrimaryAudio,
    primaryAudio
  );

  if (audioDataLoading || languageCodesLoading || validationsLoading) {
    return <VersionAudioLoader type={release?.type} />;
  }

  return languageCodes &&
    versionSongValidations &&
    releaseVersion &&
    versionValidations &&
    release?.type ? (
    <VersionAudioComponent
      type={release.type}
      audioData={audioData}
      fetchAudioDetailsValidations={fetchAudioDetailsValidations}
      updateAudioValidations={updateVersionAudioValidations}
      versionTypesDDL={versionTypesDDL || {}}
      isAudioReplacing={isAudioReplacing}
      isSyncing={isSyncing}
      primaryAudio={getPreferredAudioSelectionOption(primaryAudio)}
      primaryAudioFetching={primaryAudioFetching}
      releaseVersion={releaseVersion}
      replaceAudioVersion={replaceAudioVersion}
      updateVersion={updateVersion}
      updateAudioDetails={updateAudioDetails}
    />
  ) : null;
};
